// Branding configuration - easily switch between different brands

export const BRANDS = {
  MAX_GAMING: {
    name: 'MAX Gaming',
    logo: 'https://max.com.au/wp-content/uploads/2023/05/MAX-logo.png',
    favicon: 'https://max.com.au/wp-content/uploads/2023/05/max-favicon.png',
    colors: {
      primary: '#51276C',
      secondary: '#CF1F3B',
      buttonBg: '#CF1F3B',
      buttonText: '#FFFFFF',
      background: 'linear-gradient(135deg, #51276C 0%, #7B3F9C 100%)',
    },
    title: 'MAX Gaming',
    subtitle: 'Member Services Portal',
    serialNumber: '54U21360204',
    qrCode: {
      url: 'https://maxgaming.idvpacific.com.au/',
      bgColor: '#FFFFFF',
      fgColor: '#000000'
    },
    digitalCard: {
      templateId: '2K14v1NQaGwyFVEbpyphh',
      getPayload: (classification) => ({
        firstName: classification.First_Name || '',
        lastName: classification.Last_Name || '',
        email: 'demo@idvpacific.com.au',
        phone: '+611234567890',
        memberId: Math.floor(Math.random() * 1000000000),
        pointsKey: 1000,
        membershipType: 'VIP Member'
      })
    },
    services: [
      {
        id: 'membership-onboarding',
        title: 'Membership Onboarding',
        description: 'New member registration',
        image: '/Onboarding.png'
      },
      {
        id: 'membership-management',
        title: 'Membership Management',
        description: 'Update member details',
        image: '/management.png'
      },
      {
        id: 'gsl',
        title: 'GSL',
        description: 'Gaming Services',
        image: '/GSL.png'
      },
      {
        id: 'wymac',
        title: 'WYMAC',
        description: 'Self Exclusion Management',
        image: '/WYMAC.png'
      }
    ]
  },
  IDV_PACIFIC: {
    name: 'IDV Pacific',
    logo: 'https://idvpacific.com.au/wp-content/uploads/2018/09/IVD-Logo-retina.png',
    favicon: 'https://idvpacific.com.au/wp-content/uploads/2018/09/IVD-Logo-retina.png',
    colors: {
      primary: '#006abc',
      secondary: '#ff6600',
      buttonBg: '#ff6600',
      buttonText: '#FFFFFF',
      background: 'linear-gradient(135deg, #006abc 0%, #0080cc 100%)',
    },
    title: 'E-Kiosk Thales CR5400 Demo',
    subtitle: 'Document Scanning with IDV Pacific API',
    serialNumber: '54A20360001',
    qrCode: {
      url: 'https://idvpacific.com.au/',
      bgColor: '#FFFFFF',
      fgColor: '#000000'
    },
    digitalCard: {
      templateId: '4GirEL1WcY-vA1gN_0q8s',
      getPayload: (classification) => ({
        email: 'demo@idvpacific.com.au',
        membershipNo: Math.floor(Math.random() * 1000000000).toString(),
        firstName: classification.First_Name || '',
        lastName: classification.Last_Name || ''
      })
    },
    services: [
      {
        id: 'membership-onboarding',
        title: 'Membership Onboarding',
        description: 'New member registration',
        icon: '👤'
      },
      {
        id: 'membership-management',
        title: 'Membership Management',
        description: 'Update member details',
        icon: '📋'
      }
    ]
  },
  ALH_GROUP: {
    name: 'ALH Group',
    logo: 'https://images.squarespace-cdn.com/content/v1/588abde35016e12082207796/05fba812-6d68-4b9f-9353-c1a5ee5feb1e/ALH_Group_Logo_Transparent.png',
    favicon: 'https://images.squarespace-cdn.com/content/v1/588abde35016e12082207796/05fba812-6d68-4b9f-9353-c1a5ee5feb1e/ALH_Group_Logo_Transparent.png',
    colors: {
      primary: '#003263',
      secondary: '#f6cd59',
      buttonBg: '#f6cd59',
      buttonText: '#000000',
      background: 'linear-gradient(135deg, #003263 0%, #004a8f 100%)',
    },
    title: 'ALH Group',
    subtitle: 'Member Services Portal',
    serialNumber: '54A20360001',
    qrCode: {
      url: 'https://alhgroup.com.au/',
      bgColor: '#FFFFFF',
      fgColor: '#000000'
    },
    digitalCard: {
      templateId: '4GirEL1WcY-vA1gN_0q8s',
      getPayload: (classification) => ({
        email: 'demo@idvpacific.com.au',
        membershipNo: 'VIP Membership',
        firstName: classification.First_Name || '',
        lastName: classification.Last_Name || ''
      })
    },
    services: [
      {
        id: 'membership-onboarding',
        title: 'Membership Onboarding',
        description: 'New member registration',
        icon: '👤'
      },
      {
        id: 'membership-management',
        title: 'Membership Management',
        description: 'Update member details',
        icon: '📋'
      }
    ]
  },
  MOUNTIES: {
    name: 'Mounties',
    logo: '/img/mounties-group-seeklogo.png',
    favicon: '/img/mounties-group-seeklogo.png',
    colors: {
      primary: '#161825',
      secondary: '#EDC494',
      buttonBg: '#EDC494',
      buttonText: '#000000',
      background: 'linear-gradient(135deg, #161825 0%, #2a2d3e 100%)',
    },
    title: 'Mounties',
    subtitle: 'Member Services Portal',
    serialNumber: '54U21360204',
    qrCode: {
      url: 'https://nextpayment.idvpacific.com.au/',
      bgColor: '#FFFFFF',
      fgColor: '#000000'
    },
    digitalCard: {
      templateId: 'BbIWw-cm2RJxcaC4W5NTq',
      getPayload: (classification) => ({
        firstName: classification.First_Name || '',
        lastName: classification.Last_Name || '',
        email: 'demo@mounties.com.au',
        phone: '+611234567890',
        memberId: Math.floor(Math.random() * 1000000000),
        pointsKey: 1000,
        membershipType: 'VIP Member'
      })
    },
    services: [
      {
        id: 'membership-onboarding',
        title: 'Membership Onboarding',
        description: 'New member registration',
        image: '/Onboarding.png'
      },
      {
        id: 'membership-management',
        title: 'Membership Management',
        description: 'Update member details',
        image: '/management.png'
      },
      {
        id: 'gsl',
        title: 'GSL',
        description: 'Gaming Services',
        image: '/GSL.png'
      },
      {
        id: 'wymac',
        title: 'WYMAC',
        description: 'Self Exclusion Management',
        image: '/WYMAC.png'
      }
    ]
  }
};

// Set active brand here
export const ACTIVE_BRAND = BRANDS.MOUNTIES;
